export default __webpack_public_path__ + "static/media/increaseGraphIcon.a33947cc.svg";